import React from 'react';
import { Box, Typography } from '@mui/material';

// Budget Clues logo — magnifying glass + $ on a pink tile.
// Renders the generated PNG (public/logo192.png) so the icon is pixel-identical
// to the favicon / PWA icons and never depends on a font being available.
// Master art is public/logo-source.png; regenerate the set with
// scripts/generate-icons.js.
const BudgetCluesLogo = ({ size = 'medium', showText = true, sx = {}, mobile = false }) => {
  const sizes = {
    small: { icon: 32, text: '14px', gap: 8 },
    medium: { icon: 48, text: '20px', gap: 12 },
    large: { icon: 64, text: '28px', gap: 16 },
    mobile: { icon: 36, text: '2.1rem', gap: 12 }
  };
  const config = mobile ? sizes.mobile : (sizes[size] || sizes.medium);

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: `${config.gap}px`,
        fontFamily: 'Inter, sans-serif',
        flexShrink: 0, // prevent container from shrinking
        ...sx
      }}
    >
      {/* Logo Icon */}
      <Box
        sx={{
          width: config.icon,
          height: config.icon,
          borderRadius: `${config.icon * 0.166}px`,
          flexShrink: 0,
          boxShadow: '0 2px 8px rgba(244, 20, 104, 0.16), 0 1px 3px rgba(244, 20, 104, 0.08)',
          transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
          mb: 1,
          '&:hover': {
            boxShadow: '0 4px 12px rgba(244, 20, 104, 0.2), 0 2px 4px rgba(244, 20, 104, 0.12)',
            transform: 'translateY(-1px)'
          }
        }}
      >
        <img
          src={`${process.env.PUBLIC_URL}/logo192.png`}
          alt="Budget Clues"
          width="100%"
          height="100%"
          style={{ display: 'block' }}
        />
      </Box>

      {/* Logo Text */}
      {showText && (
        <Typography
          sx={{
            fontWeight: 800,
            fontSize: mobile ? '1.2rem !important' : `${config.text} !important`, // lock size
            color: '#F41468',
            fontFamily: 'Inter, sans-serif',
            userSelect: 'none',
            whiteSpace: 'nowrap',
            flexShrink: 0,
            lineHeight: 1,
            display: 'block'
          }}
        >
          Budget Clues
        </Typography>
      )}
    </Box>
  );
};

export default BudgetCluesLogo;

// Usage Examples:
// <BudgetCluesLogo size="small" />                    // 32px icon
// <BudgetCluesLogo size="medium" />                   // 48px icon (default)
// <BudgetCluesLogo size="large" />                    // 64px icon
// <BudgetCluesLogo size="medium" showText={false} />  // Icon only
// <BudgetCluesLogo size="large" sx={{ mb: 2 }} />     // With custom styling
